<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    
    <v-container>
            <v-layout wrap="">
    
        <v-flex xs12 sm6 md4>
                    <v-select
                    v-model="select_item_search"
                    :items="items"
                    item-text="name"
                    item-value="id"
                    label="أختر الصنف"
                    persistent-hint
                    return-object
                    single-line
                   
                ></v-select>
                  </v-flex> 
 

        <v-flex xs12 sm6 md2>
          <v-btn @click="get_last_serials">تأكيد</v-btn>
        </v-flex>
        <br />
      </v-layout>
      <v-toolbar flat color="white">
        <v-toolbar-title>السيريال</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="البحث"
          single-line
          hide-details
        ></v-text-field>

        <v-dialog
          v-model="add_dialog"
          max-width="500px"
          dir="rtl"
          align="right"
          fullscreen
        >
          <v-btn slot="activator" color="primary" dark class="mb-2"
            >اضافة سيريال</v-btn
          >
          <v-card>
            <v-card-title>
              <span class="headline">اضافة سيريال لمنتج</span>
            </v-card-title>

            <v-card-text>
              <v-form ref="form">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md4>
                      <v-select
                        v-model="select_item"
                        :items="items"
                        item-text="name"
                        item-value="id"
                        label="أختر الصنف"
                        persistent-hint
                        return-object
                        single-line
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.manger')"
                        data-vv-name="manger"
                        data-vv-scope="form1"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        type="number"
                        v-model="newItem.serial_from"
                        label=" سيريال من  "
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        type="number"
                        v-model="newItem.serial_to"
                        label=" سيريال الي   "
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        type="number"
                        v-model="newItem_count"
                        label="  العدد   "
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
              <v-btn color="blue darken-1" flat @click.native="save('form1')"
                >حفظ</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="edit_dialog"
          max-width="500px"
          dir="rtl"
          align="right"
        >
          <v-card>
            <v-card-title>
              <span class="headline">تعديل السيريال</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md4>
                    <v-select
                      disabled
                      v-model="select_item_edit"
                      :items="items"
                      item-text="name"
                      item-value="id"
                      label="أختر الصنف"
                      persistent-hint
                      return-object
                      single-line
                      v-validate="'required'"
                      :error-messages="errors.collect('form1.manger')"
                      data-vv-name="manger"
                      data-vv-scope="form1"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      type="number"
                      v-model="editedItem.serial_from"
                      label=" سيريال من  "
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      type="number"
                      v-model="editedItem.serial_to"
                      label=" سيريال الي   "
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      type="number"
                      v-model="newItem_count_edit"
                      label="  العدد   "
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
              <v-btn color="blue darken-1" flat @click="update('form2')"
                >حفظ</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="serials"
        class="elevation-1"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-right">{{ props.item.item.name }}</td>
          <td class="text-xs-right">{{ props.item.serial_from }}</td>
          <td class="text-xs-right">{{ props.item.serial_to }}</td>
          <td class="text-xs-right">{{ props.item.count }}</td>
          <td class="text-xs-right">{{ props.item.created_at }}</td>

          <td class="justify-center layout px-0">
            <v-icon small class="ml-4" @click="editItem(props.item)">
              edit
            </v-icon>
            <v-icon small @click="deleteItem(props.item)">
              delete
            </v-icon>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          dark
          dir="rtl"
          class="mypagination"
          v-model="pagination.page"
          :length="pages"
          prev-icon="chevron_right"
          next-icon="chevron_left"
        ></v-pagination>
      </div>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import {
  serials,
  add_serial,
  update_serial,
  delete_serial,
  get_last_serials
} from "../config/apiRoute.js";
import { appUrl } from "../config/apiConfig.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    appUrl: "",
    add_dialog: false,
    edit_dialog: false,
    modal1: false,
    modal2: false,
    modal3: false,
    date2: new Date().toISOString().substr(0, 10),
    date1: new Date().toISOString().substr(0, 10),
    date3: "",
    headers: [
      { text: " اسم المنتج", value: "item.name", align: "right" },
      { text: "  سيريال من", value: "serial_from", align: "right" },
      { text: "  سيريال الي ", value: "serial_to", align: "right" },
      { text: "  العدد", value: "count", align: "right" },
      { text: " التاريخ", value: "created_at", align: "center" },
      { text: "تعديل وحذف", value: "control", sortable: false, align: "center" }
    ],
    select_item_search: { id: "" },
    select_item: { id: "" },
    select_item_edit: { id: "" },
    search: "",
    loading: true,
    pagination: {
      rowsPerPage: 30,
      descending: true
    },
    items: [],
    serials: [],
    editedItem: {
      id: "",
      item_id: "",
      serial_from: "",
      serial_to: "",
      count: ""
    },
    newItem: {
      item_id: "",
      serial_from: "",
      serial_to: "",
      count: ""
    }
  }),
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
    mycode() {
      if (this.serials.length > 0) {
        return (this.code =
          parseInt(this.serials[this.serials.length - 1].code) + 1);
      } else {
        return (this.code = 1000);
      }
    },
    newItem_count() {
      let count =
        parseInt(this.newItem.serial_to) - parseInt(this.newItem.serial_from);
      return (this.newItem.count = count);
    },
    newItem_count_edit() {
      let count =
        parseInt(this.editedItem.serial_to) -
        parseInt(this.editedItem.serial_from);
      return (this.editedItem.count = count);
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.appUrl = appUrl;
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));

    this.initialize();
  },

  methods: {
    initialize() {
      serials().then(response => {
        this.serials = response.data.serials;
        this.items = response.data.items;
        this.pagination.totalItems = response.data.serials.length;
        this.loading = false;
      });
    },
    get_last_serials() {
      get_last_serials(this.select_item_search.id).then(response => {
        this.serials = response.data;
        this.pagination.totalItems = response.data.length;
        this.loading = false;
      });
    },

    editItem(item) {
      //   this.editedItem = Object.assign({}, item)
      this.initialize();
      this.editedIndex = this.serials.indexOf(item);
      this.editedItem.id = item.id;
      this.select_item_edit = { id: item.item.id, name: item.item.name };
      this.editedItem.serial_from = item.serial_from;
      this.editedItem.serial_to = item.serial_to;
      this.editedItem.count = item.count;
      this.edit_dialog = true;
    },

    deleteItem(item) {
      this.$swal({
        title: "هل تريد الأستمرار",
        text: "سيتم الحذف نهائيا ولا يمكن الرجوع",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم !",
        cancelButtonText: "لا"
      }).then(result => {
        if (result.value) {
          const index = this.serials.indexOf(item);

          this.loading = true;
          delete_serial(item.id).then(response => {
            this.loading = false;
            this.serials.splice(index, 1);
            this.close();
          });
        }
      });
    },

    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
      //   setTimeout(() => {
      //     this.editedItem = Object.assign({}, this.defaultItem)
      //     this.editedIndex = -1
      //   }, 300)
    },

    save(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.loading = true;
          this.newItem.item_id = this.select_item.id;
          var frmData = new FormData();
          frmData.append("serial", JSON.stringify(this.newItem));

          add_serial(frmData).then(response => {
            // Object.assign(this.$data.newItem, this.$options.data().newItem);
            // Object.assign(this.$data.select_bank, this.$options.data().select_bank);

            this.initialize();
            this.loading = false;
            this.close();
            setTimeout(() => {
              this.$refs.form.reset();
            }, 1000);
          });
        }
      });
    },

    update(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.loading = true;
          let item_id = this.editedItem.id;

          var frmData = new FormData();
          frmData.append("serial", JSON.stringify(this.editedItem));

          update_serial(frmData, item_id).then(response => {
            // Vue.set(
            //   this.serials,
            //   this.serials.findIndex(f => f.id === item_id),
            //   response.data
            // );
            this.initialize();
            this.loading = false;
            this.close();
          });
        }
      });
    }
  }
};
</script>

<style scope>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
</style>
